import { SpHead, SpStatusTag } from 'components/DesignKit';
import {
  Table,
  Card,
} from 'antd';
import moment from 'moment-timezone';
import React from 'react';
import currencyformatter from 'utils/currencyformatter';
import getInvoiceBackground from 'utils/getInvoiceBackground';
import getInvoiceStatus from 'utils/getInvoiceStatus';
import getPaymentBackground from 'utils/getPaymentBackground';
import getPaymentStatus from 'utils/getPaymentStatus';

type Props = {
  paymentDetails: Object,
  selectedAccount: Object,
};

const InvoicePaymentDetails = (props: Props) => {
  const {
    paymentDetails,
    selectedAccount,
  } = props;

  const columns = [
    {
      title: 'AMOUNT',
      dataIndex: 'amount',
      width: '20%',
      align: 'left',
      render: (text) => (
        <span>
          {currencyformatter(parseInt(text, 10) / 100, selectedAccount?.currency?.name) || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      width: '15%',
      align: 'left',
      render: (text) => (
        <span>
          <SpStatusTag style={{ backgroundColor: getPaymentBackground(text) }}>
            {getPaymentStatus(text) || <>&#8211;</>}
          </SpStatusTag>
        </span>
      ),
    },
    {
      title: 'METHOD',
      dataIndex: 'paymentMethod',
      width: '25%',
      align: 'left',
      render: (paymentMethod) => {
        if (!paymentMethod) {
          return (
            <span>
              <>&#8211;</>
            </span>
          );
        }
        let paymentMethodLabel = '-';
        if (paymentMethod?.card) {
          const { bankName, lastFour } = paymentMethod.card;
          paymentMethodLabel = bankName
            ? `${bankName}${lastFour ? ` **** ${lastFour}` : ''}`
            : lastFour
              ? `**** ${lastFour}`
              : ' ';
        } else if (paymentMethod?.upi) {
          const { vpa } = paymentMethod.upi;
          paymentMethodLabel = vpa || ' ';
        } else if (paymentMethod?.bank) {
          const { bankName, lastFour } = paymentMethod.bank;
          paymentMethodLabel = bankName
            ? `${bankName}${lastFour ? ` **** ${lastFour}` : ''}`
            : lastFour
              ? `**** ${lastFour}`
              : ' ';
        } else if (paymentMethod?.netbanking) {
          const { bankName } = paymentMethod.netbanking;
          paymentMethodLabel = bankName || ' ';
        } else if (paymentMethod?.googlePayUS) {
          const cardDetails = paymentMethod.googlePayUS.paymentMethodInfo?.cardDetails;
          paymentMethodLabel = cardDetails ? `**** ${cardDetails}` : '–';
        } else if (paymentMethod?.applePayUS) {
          const { cardBrand, applePayDynamicLast4 } = paymentMethod.applePayUS;
          if (cardBrand && applePayDynamicLast4) {
            paymentMethodLabel = `${cardBrand} **** ${applePayDynamicLast4}`;
          } else if (cardBrand) {
            paymentMethodLabel = cardBrand;
          } else {
            paymentMethodLabel = ' ';
          }
        } else if (paymentMethod?.instantPayment?.walletAlias) {
          const walletAlias = paymentMethod?.instantPayment?.walletAlias?.alias;
          paymentMethodLabel = walletAlias ?? ' ';
        } else if (paymentMethod?.paymentType?.name === 'QR') {
          const QrName = paymentMethod?.paymentType?.name;
          paymentMethodLabel = QrName;
        } else if (paymentMethod?.paymentType?.name === 'APPLE_PAY_US') {
          paymentMethodLabel = 'APPLE PAY';
        } else if (paymentMethod?.swirepayUS) {
          const last4 = paymentMethod?.swirepayUS?.last4;
          paymentMethodLabel = `Swirepay Rewards ${last4 ? `| Card **** ${last4}` : ' '}`;
        }
        return (
          <span>
            {paymentMethodLabel}
          </span>
        );
      },
    },
    {
      title: 'DATE',
      dataIndex: 'date',
      width: '20%',
      align: 'left',
      render: (text) => {
        let tzDate = text;
        if (selectedAccount?.timezone) {
          tzDate = moment
            .utc(text)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY');
        }
        return (
          <span>
            {tzDate || <>&#8211;</>}
          </span>
        );
      },
    },
    {
      title: 'INVOICE STATUS',
      dataIndex: 'invoiceStatus',
      width: '20%',
      align: 'left',
      render: (text) => (
        <span>
          <SpStatusTag style={{ backgroundColor: getInvoiceBackground(text) }}>
            {getInvoiceStatus(text)}
          </SpStatusTag>
        </span>
      ),
    },
  ];

  return (
    <Card>
      <SpHead>PAYMENTS FOR THIS <b>INVOICE</b></SpHead>
      <Table
        columns={columns}
        dataSource={paymentDetails}
        pagination={false}
        style={{ margin: '20px' }}
      />
    </Card>
  );
};

export default InvoicePaymentDetails;
